import React, { useContext, useEffect, useState } from "react";
import ApplicationContext from "../../../context/index";
import ApplicationDetailsForm from "./indexForm";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import { ReducerUtils } from "../../../constants/reducers";
import {
  getRoute,
  getStorageItem,
  setStorageItem,
} from "../../../helpers/utils";
import { journeyStatusNavigation } from "../../../mapping";
import { postWebService } from "../../../helpers/server";
import { useHistory } from "react-router";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";
import { Utils } from "../../../constants/utils";
import { FemaleSharp } from "@mui/icons-material";
import {
  SLUG_DEDUPE,
  SLUG_EXISTING_POLICIES,
  SLUG_TERM_PRODUCT,
  SLUG_TROP_PRODUCT,
} from "../../../constants";

function ApplicationDetails({ classes: { loaderBox } }) {
  const { state, dispatch } = useContext(ApplicationContext);
  const history = useHistory();
  const [errors, setErrors] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [modal, setModal] = useState({ alert: false });

  useEffect(() => {
    async function fetchApplicationList() {
      try {
        const response = await postWebService("proposal-listing.php", {
          mobile: getStorageItem("mobile"),
          partnerid: Number(getStorageItem("partnerId")),
        });

        cbSuccess(response.data);
      } catch (error) {
        // console.log(error);
      }
    }
    fetchApplicationList();
  }, []);

  const cbSuccess = ({ data }) => {
    dispatchEvent(ReducerUtils.proposal.list, data);
    setTimeout(() => setIsLoaded(true), 100);
  };

  const dispatchEvent = (type, payload) => dispatch({ type, payload });

  const handleClose = (keyname = "open", flag = false) =>
    toggleModal(keyname, flag);

  const handleOnClose = (event, reason, modalKey) => {
    if (Utils.dialogOnCloseReasons.indexOf(reason) === -1) {
      handleClose(modalKey, false);
    }
  };

  const toggleModal = (keyname = "alert", flag = true) =>
    setModal({ [keyname]: flag });

  const handleClick = (item) => {
    setStorageItem("dob", item.dob);
    setStorageItem("gender", item.gender);
    setStorageItem("pid", item.product_id);
    setStorageItem("productSlug", item.slug);
    setStorageItem("cid", item.cid);

    const status =
      item.status === "PROPOSALCONFIRMED"
        ? item.is_mandate === 1 || item.is_mandate === 0
          ? "BANKMANDATE"
          : "PROPOSALCONFIRMED"
        : item.status;

    cbSuccessCreateProposal(item, journeyStatusNavigation[status]);
  };

  const navigateTo = (pathname) =>
    history.push({ pathname: getRoute(pathname) });

  const checkDedupeStage = (dedupe_stage, pathname = "bankDetails") => {
    if (dedupe_stage === SLUG_DEDUPE) {
      navigateTo("existingPolicies");
    } else if (dedupe_stage === SLUG_EXISTING_POLICIES) {
      navigateTo(pathname);
    } else {
      navigateTo("dedupe");
    }
  };

  const cbSuccessCreateProposal = (
    {
      cibil_itr_stage = null,
      cid,
      idv = null,
      oid,
      slug = null,
      sumassured = null,
      dedupe_stage = null,
    },
    pathname,
    isNewProposal = false
  ) => {
    setStorageItem("cid", cid);
    setStorageItem("oid", oid);

    if (isNewProposal) {
      navigateTo(pathname);
    } else {
      if (pathname === "bankDetails") {
        if (slug === SLUG_TERM_PRODUCT || slug === SLUG_TROP_PRODUCT) {
          if (sumassured > 2500000) {
            if (cibil_itr_stage === "PROPOSES_SA_CALCULATED") {
              checkDedupeStage(dedupe_stage);
            } else if (cibil_itr_stage === "CIBIL_PENDING" && !idv) {
              navigateTo("financialUnderwriting");
            } else {
              navigateTo("regenerateBI");
            }
          } else {
            checkDedupeStage(dedupe_stage);
          }
        } else {
          checkDedupeStage(dedupe_stage);
        }
      } else {
        navigateTo(pathname);
      }
    }
  };

  const createProposal = async () => {
    try {
      const response = await postWebService("proposal-creation.php", {
        mobile: getStorageItem("mobile"),
        partnerid: Number(getStorageItem("partnerId")),
        userCategory: getStorageItem("userType") || "NONPOS",
        uid: Number(getStorageItem("uid")),
        pid: Number(state?.proposalList[0]?.product_id), // Number(getStorageItem("defaultProductId")),
        partner_branch_code: getStorageItem("partnerBranchCode") || "",
      });

      cbSuccessCreateProposal(response.data, "product", true);
    } catch (error) {
      // console.log(error);
    }
  };

  const onSubmit = (event) => {
    event.preventDefault();

    // createProposal();
    toggleModal();
  };

  return isLoaded && state?.proposalList ? (
    <ApplicationDetailsForm
      errors={errors}
      handleClick={handleClick}
      handleProceed={createProposal}
      handleOnClose={handleOnClose}
      modal={modal}
      onSubmit={onSubmit}
    />
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(ApplicationDetails);
